import { render, staticRenderFns } from "./DetailBarangEmas.vue?vue&type=template&id=1d9d5b2c&scoped=true&"
import script from "./DetailBarangEmas.vue?vue&type=script&lang=js&"
export * from "./DetailBarangEmas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9d5b2c",
  null
  
)

export default component.exports